import * as React from "react";
import { connect } from "react-redux";
import "./PodatZiadost.scss";

// actions
import * as ziadostActions from "../../actions/ziadostActions";
import * as zpCDovodActions from "../../actions/ciselniky/zpCDovodActions";
import * as zpCPrioritaActions from "../../actions/ciselniky/zpCPrioritaActions";
import * as zpCTypPraceActions from "../../actions/ciselniky/zpCTypPraceActions";
import * as mapaActions from "../../actions/mapaActions";
// coraWebComponents
import Stepper from "../../coraWebComponents/Stepper";
import withRouter from "../../coraWebComponents/utils/withRouter";
// Constants
import Routes from "../../constants/Routes";
// stepper items
import Uvod from "./Uvod";
import InfoZiadatel from "./InfoZiadatel";
import DovodZiadosti from "./DovodZiadosti";
import DetailStavby from "./DetailStavby";
import OblastZaujmu from "./OblastZaujmu";
import PrilohyKomentare from "./PrilohyKomentare";
import Rekapitulacia from "./Rekapitulacia";

import _ from "lodash";

class PodatZiadost extends React.Component {
  constructor(props) {
    super(props);

    this.childRefs = [];
    this.state = {
      isMobileView: false,
      stepperValue: 0,
      stepperItems: [
        {
          label: "Úvod",
          render: <Uvod />,
        },
        {
          label: "Info o žiadateľovi",
          render: <InfoZiadatel />,
          disabled: true,
        },
        {
          label: "Druh žiadosti",
          render: <DovodZiadosti />,
          disabled: true,
        },
        {
          label: "Detail stavby",
          render: <DetailStavby />,
          disabled: true,
        },
        {
          label: "Oblasť záujmu",
          render: <OblastZaujmu />,
          disabled: true,
        },
        {
          label: "Prílohy a komentáre",
          render: <PrilohyKomentare />,
          disabled: true,
        },
        {
          label: "Rekapitulácia",
          icon: "k-i-track-changes-accept",
          render: <Rekapitulacia />,
          disabled: true,
        },
      ],
    };
  }

  // GET visible form
  getFormElement = () => {
    const value = this.state.stepperValue;

    const webFormEl = document.getElementById(`webForm${value}`);
    const mobileFormEl = document.getElementById(`mobileForm${value}`);

    return webFormEl || mobileFormEl;
  };
  // HANDLE on change stepper
  handleOnChange = async (value) => {
    const form = this.getFormElement();

    const saveFormData = form?.reportValidity();
    if (saveFormData) {
      const childRef = this.childRefs[this.state.stepperValue];
      if (childRef?.saveData) await childRef.saveData();
    }

    if (!form || saveFormData) {
      this.moveToAnotherStepperItem(value);
    }
  };

  // REMOVE/ADD isValid prop -> user going back=>remove, forward=>add
  handleItemsProps = (nextValue) => {
    const currValue = this.state.stepperValue;
    let items = _.cloneDeep(this.state.stepperItems);

    items = items.map((item, i) => {
      delete item.isValid;

      if (i < nextValue) item["isValid"] = true;
      if (i === currValue) item.disabled = false;

      return item;
    });

    return items;
  };
  // MOVE to next/previous stepper item
  moveToAnotherStepperItem = (value) => {
    const items = this.handleItemsProps(value);

    this.setState((state) => ({
      ...state,
      stepperValue: value,
      stepperItems: [...items],
    }));
  };
  // HANDLE next(submit) button
  handleOnClickNext = (e = null) => {
    if (e) e.preventDefault();
    this.handleOnChange(this.state.stepperValue + 1);
  };
  // HANDLE back button
  handleOnClickBack = (e = null) => {
    if (e) e.preventDefault();
    this.handleOnChange(this.state.stepperValue - 1);
  };
  // HANDLE cancel button
  handleOnClickCancel = () => {
    this.props.navigate(Routes.HOME);
  };
  // HANDLE on enter pressed in form
  handleOnKeyDown = (e) => {
    if (e.key === "Enter") e.preventDefault();
  };
  // SAVE refs of childs
  setRef = (childRef, i) => {
    this.childRefs[i] = childRef;
  };

  // SYSTEM methods
  componentWillUnmount = () => {
    const el = document.getElementsByClassName("scrollable-body");
    if (el[0]?.classList) el[0].classList.remove("overflow-y-hidden");
  };
  componentDidMount = () => {
    const el = document.getElementsByClassName("scrollable-body");
    if (el[0]?.classList) el[0].classList.add("overflow-y-hidden");

    this.props.changeZiadost(null);
    this.props.changeDovod(null);
    this.props.changePriorita(null);
    this.props.changeTypPrace(null);
    this.props.changeImage(null);
    this.props.changeExtentCoords(null, null);
  };

  render() {
    const { stepperValue, stepperItems } = this.state;

    return (
      <>
        <Stepper
          name="stepperValue"
          items={stepperItems}
          value={stepperValue}
          handleChange={this.handleOnChange}
        />
        {stepperItems.map((item, i) => {
          const className = i === stepperValue ? "podatZiadostScrollItem" : "displayNone";
          const props = {
            setRef: (ref) => this.setRef(ref, i),
            moveNext: this.handleOnClickNext,
            moveBack: this.handleOnClickBack,
            cancel: this.handleOnClickCancel,
            onKeyDown: this.handleOnKeyDown,
            className,
            index: i,
            key: i,
            ziadost: this.props.ziadost
          };
          return React.cloneElement(item.render, props);
        })}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  ziadost: state.ziadost.data
});

const mapDispatchToProps = (dispatch) => ({
  changeZiadost: (ziadost) => dispatch(ziadostActions.changeZiadost(ziadost)),
  changeDovod: (dovod) => dispatch(zpCDovodActions.changeDovod(dovod)),
  changePriorita: (priorita) => dispatch(zpCPrioritaActions.changePriorita(priorita)),
  changeTypPrace: (typPrace) => dispatch(zpCTypPraceActions.changeTypPrace(typPrace)),
  changeExtentCoords: (extent, coords) => dispatch(mapaActions.changeExtentCoords(extent, coords)),
  changeImage: () => dispatch(mapaActions.changeImage()),
});

PodatZiadost.propTypes = {
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PodatZiadost)
);
